import type { RankingChartLabels } from '@digital-twins/deck-ui/components'

import i18n, { resolveUiLanguage } from '@/i18n'

/**
 * Pre-translated RankingChart labels for a study/thread content language.
 * Cache scope: one-shot per mount; rebuilt when content language changes.
 * Never reads UI chrome language (`i18n.language`).
 */
export function rankingChartLabelsForLanguage(
  contentLanguage?: string | null,
): RankingChartLabels {
  const locale = resolveUiLanguage(contentLanguage)
  const t = i18n.getFixedT(locale, 'app')

  return {
    score: t('rankingChart.score'),
    higherScoreMorePreferred: t('rankingChart.higherScoreMorePreferred'),
    formatScoreRange(max: number) {
      return t('rankingChart.scoreRange', { max })
    },
    formatShowingTopItems(shown: number, total: number) {
      return t('rankingChart.showingTopItems', { shown, total })
    },
    formatShowingTopRankedItems(shown: number, total: number) {
      return t('rankingChart.showingTopRankedItems', { shown, total })
    },
    formatSegmentBarTitle(segment: string, score: string, count: number) {
      return t('rankingChart.segmentBarTitle', { segment, score, count })
    },
    empty: t('rankingChart.empty'),
  }
}
